import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';
import { WorkingMode } from 'types';

export const userInterviewLabelOptions = [
	{ value: WorkingMode.FULL_TIME, label: 'Full Time' },
	{ value: WorkingMode.INTERNSHIP, label: 'Internship' },
	{ value: WorkingMode.INTERNSHIP_TO_FULL_TIME, label: 'Internship to Full Time' },
];

const DriveUserInterviewLabelFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const userInterviewLabel = JSON.parse(searchParams.get('userInterviewLabel') || '[]');

	const options = userInterviewLabelOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!userInterviewLabel?.length}
					placeholder={'User Interview Category'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: userInterviewLabel?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (userInterviewLabel?.includes(option?.value?.toString())) {
											searchParams.set(
												'userInterviewLabel',
												JSON.stringify(userInterviewLabel?.filter((status: string) => status !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('userInterviewLabel', JSON.stringify([...userInterviewLabel, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{userInterviewLabel?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">User Interview Label</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="User Interview Label"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => userInterviewLabel?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('userInterviewLabel', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserInterviewLabelFilterInput;
